import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "table-transmission",
  style: {"margin-top":"3%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Periodo Nómina"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha inicio pago NE"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha fin pago NE"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha de pago 1"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha de pago 2"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha de pago 3"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha de pago 4")
], -1)
const _hoisted_3 = { class: "error-transmission" }
const _hoisted_4 = { class: "tooltip-container" }
const _hoisted_5 = { class: "tooltip-container" }
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = { colspan: "2" }
const _hoisted_9 = { class: "tooltip-container" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_11 = { class: "table-transmission" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Forma de pago"),
  /*#__PURE__*/_createElementVNode("th", null, "Método de pago"),
  /*#__PURE__*/_createElementVNode("th", null, "Banco"),
  /*#__PURE__*/_createElementVNode("th", null, "Tipo de cuenta"),
  /*#__PURE__*/_createElementVNode("th", null, "Número de cuenta"),
  /*#__PURE__*/_createElementVNode("th", null, "Tipo de moneda"),
  /*#__PURE__*/_createElementVNode("th", null, "TRM")
], -1)
const _hoisted_13 = { class: "error-transmission" }
const _hoisted_14 = { class: "tooltip-container" }
const _hoisted_15 = { class: "tooltip-container" }
const _hoisted_16 = { class: "tooltip-container" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_18 = { class: "tooltip-container" }
const _hoisted_19 = { class: "tooltip-container" }
const _hoisted_20 = { class: "tooltip-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_Dropdown, {
              showClear: "",
              modelValue: $setup.periodo,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.periodo) = $event)),
              options: $setup.PeriodoNomina(),
              optionLabel: "abreviatura",
              optionValue: "abreviatura",
              placeholder: "Seleccione",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PayrollPeriodCode.$error }]),
              onChange: $setup.CodigoPeriodoNomina,
              onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.v$.PayrollPeriodCode.$touch()))
            }, null, 8, ["modelValue", "options", "onChange", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Calendar, {
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PayrollStartSettlementDate.$error }]),
              dateFormat: "yy-mm-dd",
              showButtonBar: "",
              modelValue: $setup.nominaElectronica.StartSettlementDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.nominaElectronica.StartSettlementDate) = $event)),
              onBlur: _cache[3] || (_cache[3] = ($event: any) => ($setup.v$.PayrollStartSettlementDate.$touch()))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Calendar, {
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PayrollEndSettlementDate.$error }]),
              dateFormat: "yy-mm-dd",
              showButtonBar: "",
              modelValue: $setup.nominaElectronica.EndSettlementDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.nominaElectronica.EndSettlementDate) = $event)),
              onBlur: _cache[5] || (_cache[5] = ($event: any) => ($setup.v$.PayrollEndSettlementDate.$touch()))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Calendar, {
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PayrollPaymentDates.$error }]),
              dateFormat: "yy-mm-dd",
              showButtonBar: "",
              onBlur: $setup.ValidarFechasPago,
              modelValue: $setup.nominaElectronica.PaymentDates[0],
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.nominaElectronica.PaymentDates[0]) = $event))
            }, null, 8, ["onBlur", "modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Calendar, {
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PayrollPaymentDates.$error }]),
              dateFormat: "yy-mm-dd",
              showButtonBar: "",
              onBlur: $setup.FormatearFechas,
              modelValue: $setup.nominaElectronica.PaymentDates[1],
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.nominaElectronica.PaymentDates[1]) = $event))
            }, null, 8, ["onBlur", "modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Calendar, {
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PayrollPaymentDates.$error }]),
              dateFormat: "yy-mm-dd",
              showButtonBar: "",
              onBlur: $setup.FormatearFechas,
              modelValue: $setup.nominaElectronica.PaymentDates[2],
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.nominaElectronica.PaymentDates[2]) = $event))
            }, null, 8, ["onBlur", "modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Calendar, {
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PayrollPaymentDates.$error }]),
              dateFormat: "yy-mm-dd",
              showButtonBar: "",
              onBlur: $setup.FormatearFechas,
              modelValue: $setup.nominaElectronica.PaymentDates[3],
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.nominaElectronica.PaymentDates[3]) = $event))
            }, null, 8, ["onBlur", "modelValue", "class"])
          ])
        ]),
        _createElementVNode("tr", _hoisted_3, [
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PayrollPeriodCode.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.PayrollPeriodCode.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PayrollStartSettlementDate.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.PayrollStartSettlementDate.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PayrollEndSettlementDate.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.PayrollEndSettlementDate.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _hoisted_7,
          _createElementVNode("td", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PayrollPaymentDates.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.PayrollPaymentDates.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _hoisted_10
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_Dropdown, {
              showClear: "",
              modelValue: $setup.forma,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.forma) = $event)),
              options: $setup.FormaPago(),
              optionLabel: "abreviatura",
              optionValue: "abreviatura",
              placeholder: "Seleccione",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PaymentMeanCode.$error }]),
              onChange: $setup.CodigoFormaPago,
              onInput: _cache[11] || (_cache[11] = ($event: any) => ($setup.v$.PaymentMeanCode.$touch()))
            }, null, 8, ["modelValue", "options", "onChange", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Dropdown, {
              showClear: "",
              filter: "",
              modelValue: $setup.metodo,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.metodo) = $event)),
              options: $setup.MetodoPago(),
              optionLabel: "abreviatura",
              optionValue: "abreviatura",
              placeholder: "Seleccione",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PaymentMethodCode.$error }]),
              onChange: $setup.CodigoMetodoPago,
              onInput: _cache[13] || (_cache[13] = ($event: any) => ($setup.v$.PaymentMethodCode.$touch()))
            }, null, 8, ["modelValue", "options", "onChange", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: $setup.nominaElectronica.Bank,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.nominaElectronica.Bank) = $event)),
              onChange: _cache[15] || (_cache[15] = ($event: any) => ($setup.v$.Bank.$touch())),
              class: _normalizeClass({ 'p-invalid': $setup.v$.Bank.$error })
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Dropdown, {
              showClear: "",
              filter: "",
              modelValue: $setup.cuenta,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.cuenta) = $event)),
              options: $setup.TipoCuenta(),
              optionLabel: "abreviatura",
              optionValue: "abreviatura",
              placeholder: "Seleccione",
              class: "pv-input-size",
              onChange: $setup.CodigoTipoCuenta
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: $setup.nominaElectronica.AccountNumber,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.nominaElectronica.AccountNumber) = $event)),
              onChange: _cache[18] || (_cache[18] = ($event: any) => ($setup.v$.AccountNumber.$touch())),
              class: _normalizeClass({ 'p-invalid': $setup.v$.AccountNumber.$error })
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Dropdown, {
              showClear: "",
              filter: "",
              modelValue: $setup.moneda,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.moneda) = $event)),
              options: $setup.TipoMoneda(),
              optionLabel: "abreviatura",
              optionValue: "abreviatura",
              placeholder: "Seleccione",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.CurrencyCode.$error }]),
              onChange: $setup.CodigoMoneda,
              onInput: _cache[20] || (_cache[20] = ($event: any) => ($setup.v$.CurrencyCode.$touch()))
            }, null, 8, ["modelValue", "options", "onChange", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.Trm.$error }]),
              minFractionDigits: 0,
              onBlur: _cache[21] || (_cache[21] = ($event: any) => ($setup.v$.Trm.$touch())),
              modelValue: $setup.nominaElectronica.Trm,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.nominaElectronica.Trm) = $event))
            }, null, 8, ["modelValue", "class"])
          ])
        ]),
        _createElementVNode("tr", _hoisted_13, [
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PaymentMeanCode.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.PaymentMeanCode.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PaymentMethodCode.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.PaymentMethodCode.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.Bank.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.Bank.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _hoisted_17,
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.AccountNumber.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.AccountNumber.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.CurrencyCode.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.CurrencyCode.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.Trm.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.Trm.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}